import { render, staticRenderFns } from "./UpdatedChange.vue?vue&type=template&id=278d4ac2&"
import script from "./UpdatedChange.vue?vue&type=script&lang=js&"
export * from "./UpdatedChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports